export const LOGIN_PAGE_NS = "LoginPage";

export const i18n = {
  en: {
    form: {
      userType: {
        label: "Role:",
      },
      rank: {
        placeholder: "Enter rank",
        label: "Rank:",
        hint: "Please include your rank for use on electronic delivery documentation",
      },
      displayName: {
        placeholder: "Enter full name",
        label: "Full name:",
        hint: "Please include your full name for use on electronic delivery documentation",
      },
      email: {
        placeholder: "Enter email address",
        label: "Email address:",
        hint: "Please include your email for use on electronic delivery documentation",
      },
      licenseNumber: {
        placeholder: "Enter license number",
        label: "License number:",
        hint: "Please include your license number for use on electronic delivery documentation",
      },
      vesselName: {
        placeholder: "Enter vessel name",
        label: "Vessel name:",
        hint: "Please include the vessel name for use on electronic delivery documentation",
      },
      password: {
        placeholder: "Enter password",
        label: "Password:",
      },
    },
    error: {
      password: "Invalid email or password",
      generic:
        "Incorrect email address or One Time Password\nPlease enter the One Time Password that has been sent to your email, or click {{button}} if you haven't received it yet.",
    },
    button: {
      guest: "Access ADP",
      user: "Login",
      requestOtp: "Request One Time Password",
    },
    restorePassword: {
      forgot: "Forgot password?",
      alt: "Please visit idiana.io to reset your password",
    },
    documentTitle: {
      sync: "Syncing...",
      login: "Login",
    },
    syncing: {
      sync: "Syncing...",
      message: "An error has occurred during the initial data synchronisation",
      button: {
        reset: "Reset installation",
        restart: "Restart onboard service",
      },
      notification: {
        message: "Error",
        reset: "Could not reset system (an unknown error occurred)",
        restart: "Could not restart system (an unknown error occurred)",
      },
    },
  },
};
